import { SystemStyleObject } from "@chakra-ui/react";

export const formFieldVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.08,
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  }),
};

export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

export const inputStyles: SystemStyleObject = {
  bg: "white",
  border: "1px solid",
  borderColor: "gray.300",
  borderRadius: "lg",
  py: 5,
  px: 4,
  fontSize: "md",
  transition: "all 0.2s ease",
  _hover: {
    borderColor: "gray.400",
  },
  _focus: {
    borderColor: "teal.500",
    boxShadow: "0 0 0 1px var(--chakra-colors-teal-500)",
  },
  _placeholder: {
    color: "gray.400",
  },
};

export const labelStyles: SystemStyleObject = {
  fontSize: "sm",
  fontWeight: "500",
  color: "gray.700",
  mb: 1,
};

export const getIconContainerStyles = (isTyping: boolean, isFormValid: boolean): SystemStyleObject => ({
  "@keyframes float": {
    "0%, 100%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-3px)" },
  },
  animation: isTyping ? "none" : "float 3s ease-in-out infinite",
  transition: "transform 0.3s ease",
  "&:hover": isFormValid ? {
    transform: "scale(1.05)",
  } : {},
  "&:active": isFormValid ? {
    transform: "scale(0.95)",
  } : {},
});

export const iconWrapperStyles: SystemStyleObject = {
  w: 14,
  h: 14,
  bg: "linear-gradient(135deg, #1a202c 0%, #2d3748 100%)",
  borderRadius: "xl",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255,255,255,0.1) inset",
  position: "relative",
  overflow: "hidden",
  _before: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "50%",
    background: "linear-gradient(180deg, rgba(255,255,255,0.1) 0%, transparent 100%)",
    borderRadius: "xl xl 0 0",
  },
};

export const badgeStyles: SystemStyleObject = {
  position: "absolute",
  top: "-2px",
  right: "-2px",
  w: 5,
  h: 5,
  bg: "teal.500",
  borderRadius: "full",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 2px 8px rgba(49, 151, 149, 0.5)",
  border: "2px solid",
  borderColor: "gray.50",
};

export const cardStyles: SystemStyleObject = {
  bg: "white",
  borderRadius: "xl",
  boxShadow: "sm",
  border: "1px solid",
  borderColor: "gray.200",
  transition: "box-shadow 0.2s ease",
  _hover: { boxShadow: "md" },
};

export const shimmerBarStyles: SystemStyleObject = {
  h: 1,
  bg: "linear-gradient(90deg, #319795 0%, #38B2AC 50%, #319795 100%)",
  backgroundSize: "200% 100%",
  animation: "shimmer 4s ease-in-out infinite",
  borderTopLeftRadius: "xl",
  borderTopRightRadius: "xl",
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "200% 0" },
    "100%": { backgroundPosition: "-200% 0" },
  },
};

export const footerStyles: SystemStyleObject = {
  px: 8,
  py: 5,
  bg: "gray.50",
  borderTop: "1px solid",
  borderColor: "gray.200",
  borderBottomLeftRadius: "xl",
  borderBottomRightRadius: "xl",
};

export const disabledButtonStyles: SystemStyleObject = {
  bg: "gray.300",
  cursor: "not-allowed",
};

export const dropdownStyles: SystemStyleObject = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  mt: 1,
  bg: "white",
  borderRadius: "lg",
  boxShadow: "lg",
  border: "1px solid",
  borderColor: "gray.200",
  zIndex: 1000,
  maxH: "320px",
  overflowY: "auto",
};

export const dropdownItemStyles: SystemStyleObject = {
  px: 4,
  py: 3,
  cursor: "pointer",
  _hover: { bg: "gray.50" },
  transition: "background 0.15s",
  borderBottom: "1px solid",
  borderColor: "gray.100",
  _last: { borderBottom: "none" },
};

export const clearButtonStyles: SystemStyleObject = {
  cursor: "pointer",
  color: "gray.400",
  _hover: { color: "gray.600" },
  transition: "color 0.2s",
};
